import React from 'react';
import _ from 'lodash';
import { Box, FormControl, FormHelperText, InputLabel, Select, MenuItem, Checkbox, ListItemText, Typography, Stack, ListSubheader } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { RequiredField } from '../others/RequiredField';
import { InfoField } from './InfoField';
import { handleShowOn } from '../../services/functions';
import { useDidMountEffect, useFullScreen } from '../../services/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const MultiChoiceField = props => {
  const { field, formik, getFieldCallback, checkActivitiesCallback, formVersion, metaData } = props;
  const maxWidth = useFullScreen() ? 'calc(100vw - 100px)' : 'calc(100vw - 380px)';
  const [selectedNames, setSelectedNames] = React.useState([]);
  const [activitiesMessage, setActivitiesMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const textStyle = field.name === 'discount_code_promotions'
    ? { '& .MuiSelect-select': {
      color: 'red'
    },
    '&.Mui-disabled .MuiSelect-select': {
      color: 'red',
      WebkitTextFillColor: 'red',
      opacity: 1
    } } : {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.light'
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.main'
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'primary.dark'
      }
    };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleChange = item => {
    // Zajęcia ZS
    if (field.name == 'main_activities') {
      handleMainActivitiesChange(item);
    } else if (field.name == 'discount_code_promotions') {
      // Pole disabled, aktualizuje się samo po wpisaniu kodu
    }
  };

  const handleMainActivitiesChange = item => {
    let arr = formik.values[field.name];
    let namesArr = selectedNames;
    const idx = arr.indexOf(item.id) > -1;
    if ((/^202[456789]/).test(formVersion.toString())) {

      // Sezon 2024+:
      if (idx) {
        arr = arr.filter(val => val !== item.id);
        namesArr = namesArr.filter(val => val !== item.name);
        const { currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax } = checkActivitiesCallback('remove', item, field, formik.values[field.name]);
        setActivitiesMessage(`łącznie: ${currentMainActivities + currentRopeActivities + currentEducationalActivities + currentEntertainmentActivities + currentIntegrationActivities}/${mainActivitiesMax} edukacyjne: ${currentEducationalActivities}/${educationalActivitiesMax} rozrywkowe: ${currentEntertainmentActivities}/${entertainmentActivitiesMax} integracyjne: ${currentIntegrationActivities}/${integrationActivitiesMax}`);
      } else {
        if (field.name == 'main_activities') {
          const { error, message, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, currentEntertainmentActivities, entertainmentActivitiesMax, currentIntegrationActivities, integrationActivitiesMax } = checkActivitiesCallback('add', item, field, formik.values[field.name]);
          setActivitiesMessage(`łącznie: ${currentMainActivities + currentRopeActivities + currentEducationalActivities + currentEntertainmentActivities + currentIntegrationActivities}/${mainActivitiesMax} edukacyjne: ${currentEducationalActivities}/${educationalActivitiesMax} rozrywkowe: ${currentEntertainmentActivities}/${entertainmentActivitiesMax} integracyjne: ${currentIntegrationActivities}/${integrationActivitiesMax}`);
          if (error) {
            // eslint-disable-next-line no-alert
            alert(message);

            return null;
          }
        }
        arr.push(item.id);
        namesArr.push(item.name);
      }
      // Sezon 2023
    } else if (idx) {
      arr = arr.filter(val => val !== item.id);
      namesArr = namesArr.filter(val => val !== item.name);
      const { currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent } = checkActivitiesCallback('remove', item, field, formik.values[field.name]);
      setActivitiesMessage(`łącznie: ${currentMainActivities + currentRopeActivities + currentEducationalActivities + artisticActivityIsPresent}/${mainActivitiesMax + ropeActivitiesMax + educationalActivitiesMax} edukacyjne: ${currentEducationalActivities}/${educationalActivitiesMax} artystyczne: ${artisticActivityIsPresent}/1`);
    } else {
      if (field.name == 'main_activities') {
        const { error, message, currentMainActivities, mainActivitiesMax, currentRopeActivities, ropeActivitiesMax, currentEducationalActivities, educationalActivitiesMax, artisticActivityIsPresent } = checkActivitiesCallback('add', item, field, formik.values[field.name]);
        setActivitiesMessage(`łącznie: ${currentMainActivities + currentRopeActivities + currentEducationalActivities + artisticActivityIsPresent}/${mainActivitiesMax + ropeActivitiesMax + educationalActivitiesMax} edukacyjne: ${currentEducationalActivities}/${educationalActivitiesMax} artystyczne: ${artisticActivityIsPresent}/1`);
        if (error) {
        // eslint-disable-next-line no-alert
          alert(message);

          return null;
        }
      }
      arr.push(item.id);
      namesArr.push(item.name);
    }
    formik.setFieldValue(field.name, arr);
    setSelectedNames(namesArr);
  };


  useDidMountEffect(() => {
    if (!field.hide) {
      setSelectedNames([]);
      setActivitiesMessage('');

    }
  }, [field.hide]);

  useDidMountEffect(() => {
    const selectedNames = [];
    formik.values.discount_code_promotions.map(dcp => {
      const fullPromotion = metaData.promotions.find(p => p.id == dcp);
      if (fullPromotion) {
        selectedNames.push(fullPromotion.name);
      }
    });
    setSelectedNames(selectedNames);
  }, [formik.values.discount_code_promotions]);

  useDidMountEffect(() => {
    setSelectedNames([]);
    formik.setFieldValue('discount_code_promotions', []);
  }, [formik.values.camp]);

  return (
    <Box style={{ display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}>
      <Stack direction="row">
        <Typography variant="subtitle1" >
          <b>{field.label}</b>
          <RequiredField required={field.required} isEmpty={_.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && formik.errors[field.name]} />
        </Typography>
        {field.label == 'Zajęcia' ? <Typography variant="button" color="primary" sx={{ ml: 3 }}>{activitiesMessage}</Typography> : ''}
      </Stack>
      <FormControl
        style={{ marginBottom: 15, maxWidth }}
        fullWidth
        variant="standard"
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}>
        <InputLabel id={field.name}>{_.isEmpty(formik.values[field.name]) ? field.label : null}</InputLabel>
        <Select
          sx={textStyle}
          multiple
          labelId={field.name}
          value={formik.values[field.name] || ''}
          open = {open}
          onOpen = {handleOpen}
          onClose = {handleClose}
          disabled={field.disabled}
          renderValue={selected => selectedNames.join(', ')}
          MenuProps={
            {
              PaperProps: {
                style: {
                  maxHeight: 280
                }
              }
            }
          }
          IconComponent={_props => {
            const rotate = _props.className.toString().includes('iconOpen');

            return (
              <div>
                { rotate
                  ? <div style={{ color: 'red', cursor: 'pointer', marginRight: 5, marginBottom: 5, fontSize: 20 }}>X</div>
                  : <div><KeyboardArrowDownIcon
                    style={{ cursor: 'pointer' }}
                    onClick = {handleOpen}
                  /></div> }
              </div>
            );
          }}

        >
          {!_.isNil(formik.values[field.name])
            ? !_.isNil(field.dynamicOptions)
              ? field.label === 'Zajęcia'
                ? _.chain(field.dynamicOptions)
                  .groupBy(item => item.category || 'Pozostałe')
                  .map((items, category) => [
                    <ListSubheader key={`category-${category}`} color="primary">
                      {category}
                    </ListSubheader>,
                    ...items.map(item => (
                      <MenuItem
                        style={{ whiteSpace: 'normal' }}
                        key={item.id}
                        value={item.id}
                        data-description={item.description}
                        onChange={() => handleChange(item)}
                        disabled={
                          item.name.includes('ARENA NINJA') ||
                        item.name.includes('SUNMAGEDON')
                        }
                      >
                        <Checkbox
                          checked={formik.values[field.name].indexOf(item.id) > -1}
                        />
                        <ListItemText primary={item.name} />
                      </MenuItem>
                    ))
                  ])
                  .flatten()
                  .value()
                : _.map(field.dynamicOptions, (item, key) => (
                  <MenuItem
                    style={{ whiteSpace: 'normal' }}
                    key={key}
                    value={item.id}
                    data-description={item.description}
                    onChange={() => handleChange(item)}
                    disabled={
                      item.name.includes('ARENA NINJA') ||
              item.name.includes('SUNMAGEDON')
                    }
                  >
                    <Checkbox
                      checked={formik.values[field.name].indexOf(item.id) > -1}
                    />
                    <ListItemText primary={item.name} />
                  </MenuItem>
                ))
              : !_.isNil(field.dict_identifier)
                ? _.map(field.options, (item, key) => (
                  <MenuItem key={key} value={item.id} onChange={() => handleChange(item)}>
                    <Checkbox checked={formik.values[field.name].indexOf(item.id) > -1} />
                    <ListItemText primary={item.name} />
                  </MenuItem>
                ))
                : _.map(field.options, (item, key) => (
                  <MenuItem key={key} value={item.id} onChange={() => handleChange(item)}>
                    <Checkbox checked={formik.values[field.name].indexOf(item.id) > -1} />
                    <ListItemText primary={item.name} />
                  </MenuItem>
                ))
            : null}
        </Select>
        <FormHelperText>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />)
            : null
        }
        { field.dynamicOptions && field.dynamicOptions.find(item => item.name.includes('ARENA NINJA')) &&
          <Typography variant="subtitle" color="green" style={{ paddingBottom: 7, paddingTop: 7 }}>
            <FontAwesomeIcon
              icon={['fas', 'info-circle']}
              color={'green'} />
                Wybrali Państwo ofertę ARENA NINJA, która będzie realizowana podczas trzech bloków zajęciowych. Podczas dwóch bloków zajęciowych odbędzie się zajęcie „Tor przeszkód ARENA NINJA”. Prosimy o wybór trzeciego zajęcia, które zrealizowane będzie podczas trzeciego bloku zajęciowego.
          </Typography>
        }
        { field.dynamicOptions && field.dynamicOptions.find(item => item.name.includes('SUNMAGEDON')) &&
          <Typography variant="subtitle" color="green" style={{ paddingBottom: 7, paddingTop: 7 }}>
            <FontAwesomeIcon
              icon={['fas', 'info-circle']}
              color={'green'} />
                Wybrali Państwo ofertę SUNMAGEDON, która będzie realizowana podczas trzech bloków zajęciowych. Podczas dwóch bloków zajęciowych odbędzie się zajęcie „Tor przeszkód SUNMAGEDON. Prosimy o wybór trzeciego zajęcia, które zrealizowane będzie podczas trzeciego bloku zajęciowego.
          </Typography>
        }
      </FormControl>
    </Box>
  );
};
